import { useAuthStore } from "../store"
import { CrudCollection } from "@hc/graphql"

export const useWorkflow = () => {

  const auth = useAuthStore()

  const isActivePermittedWorkflows = (item, collection: CrudCollection) => {
    return collection.workflow?.actions?.some(action =>
      auth.access[collection.typename][action.name] && action.options.isActive(item)
    )
  }

  return {
    isActivePermittedWorkflows
  }

}